import SEO from "../components/SEO";
import LandingNav from "../components/landing/LandingNav";
import LandingHero from "../components/landing/LandingHero";
import LandingHighlights from "../components/landing/LandingHighlights";
import LandingFeatures from "../components/landing/LandingFeatures";
import LandingHowItWorks from "../components/landing/LandingHowItWorks";
import LandingBatchShowcase from "../components/landing/LandingBatchShowcase";
import LandingTrustStrip from "../components/landing/LandingTrustStrip";
import LandingPricing from "../components/landing/LandingPricing";
import LandingFAQ from "../components/landing/LandingFAQ";
import LandingFooter from "../components/landing/LandingFooter";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <SEO
        title="hireqix Resume Screener — Batch Candidate Scoring for Hiring Teams"
        description="Score bulk resumes against custom job competencies and rank candidates into collapsible Batch 1, 2, 3 tables without losing existing scores."
        keywords="resume screener, resume screening software, candidate scoring, batch candidate ranking, competency matrix, hiring software, applicant tracking, HR automation"
        canonicalPath="/"
      />
      <LandingNav />
      <LandingHero />
      <LandingHighlights />
      <LandingFeatures />
      <LandingHowItWorks />
      <LandingBatchShowcase />
      <LandingTrustStrip />
      <LandingPricing />
      <LandingFAQ />
      <LandingFooter />
    </div>
  );
}
